import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

import './i18n.ts'
import Providers from './context/Context.tsx'

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <Providers>
    <App />
  </Providers>
  // </React.StrictMode>,
)
